/* eslint no-use-before-define: "off" */

export { loadGoogleFont };

const loadGoogleFont = (family: string) => {
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.type = 'text/css';
  const css = `@import url('https://fonts.googleapis.com/css?family=${family.replace(
    /\s/gi,
    '+'
  )}');`;
  style.appendChild(document.createTextNode(css));
  head.appendChild(style);
};
